import { useQuery } from '@tanstack/react-query';

import { SlideApiResponse } from '../../types/api';

import { fetchSlidesData } from '../queries/fetchSlidesData';

export const useSlides = (workspaceId?: string | null) => {
  return useQuery<SlideApiResponse, Error>({
    queryKey: ['slides', workspaceId],
    queryFn: () => {
      if (!workspaceId) return Promise.reject(new Error('No workspaceId provided'));
      return fetchSlidesData(workspaceId);
    },
    // Управляем вручную вызовом refetch() на маунте страницы
    enabled: false,
    retry: 0,
    refetchOnMount: false,
    // Данные считаются свежими до явной инвалидации
    staleTime: Infinity,
    // Кеш держим подольше, чтобы переживать переходы между страницами
    gcTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
};
